<template>
  <div class="issues-bar-chart-container">
    <div class="issues-bar-chart">
      <div
        class="issues-bar-chart__category-item color-tab"
        v-for="(i, index) in series"
        :key="index + i.name"
        :style="{
          display: 'inline-block',
          width: i.data[0] + '%',
          backgroundColor: colors[i.colorIndex],
        }" >
      </div>
      <div class="issues-bar-chart__label-container row no-gutters">
        <div
          class="issues-bar-chart__category-label col-md-4"
          v-for="(i, index) in series"
          :key="index + i.name + 'label'"
          :style="{
            borderLeft: `6px solid ${colors[i.colorIndex]}`
          }" >
          <h4
            class="p-0 m-0"
            :style="{
              color: colors[i.colorIndex],
            }" >
            {{ i.data[0].toFixed(2) }}%
          </h4>
          <div>
            {{ i.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: ['series', 'colors'],
  computed: {
    filteredSeries() {
      return _.filter(this.series, s => s.data[0] > 0);
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.color-tab {
  position: relative;
  height: 50px;
}

.issues-bar-chart-container {
  padding: $spacer;
}
// .issues-bar-chart__label-container {
// }
.issues-bar-chart__category-label {
  display: inline-block;
  padding: $spacer * .5;
  margin-top: $spacer * .5;
}
</style>
